const apiDomain = (val) => {
    const splitDomain = val.split(".");
    const domainLength = splitDomain.length;

    // ตรวจ base domain เช่น test.com
    const baseDomain =
        domainLength === 1 ? splitDomain[0] :
        domainLength === 2 ? splitDomain.join(".") :
        splitDomain.slice(-2).join(".");

    // ตรวจ protocol
    const protocol = typeof window !== "undefined" && window.location.protocol === "https:" ? "https" : "http";

    return `${protocol}://api.${baseDomain}/api/v1`;
};

export default apiDomain;
